import servise from '@/router/axios'

// 分页查询 RTA 绑定关系列表
export const getRtaBindPage = (params) => {
  return servise({
    url: '/ocpx/rta-bind/page',
    method: 'get',
    params
  })
}

// 根据 ID 查询绑定关系详情
export const getRtaBindById = (id) => {
  return servise({
    url: `/ocpx/rta-bind/${id}`,
    method: 'get'
  })
}

// 绑定渠道RTA和广告主RTA
export const bindRta = (data) => {
  return servise({
    url: '/ocpx/rta-bind/bind',
    method: 'post',
    data
  })
}

// 更新绑定关系
export const updateRtaBind = (data) => {
  return servise({
    url: '/ocpx/rta-bind/update',
    method: 'put',
    data
  })
}

// 解绑
export const unbindRta = (id) => {
  return servise({
    url: `/ocpx/rta-bind/unbind/${id}`,
    method: 'delete'
  })
}

// 更新绑定关系状态
export const updateRtaBindStatus = (id, status) => {
  return servise({
    url: `/ocpx/rta-bind/${id}/status/${status}`,
    method: 'put'
  })
}

// 根据渠道RTA ID查询绑定关系列表
export const getRtaBindByChannelRtaId = (channelRtaId) => {
  return servise({
    url: `/ocpx/rta-bind/channel/${channelRtaId}`,
    method: 'get'
  })
}

// 根据广告主RTA ID查询绑定关系列表
export const getRtaBindByAdvertiserRtaId = (advertiserRtaId) => {
  return servise({
    url: `/ocpx/rta-bind/advertiser/${advertiserRtaId}`,
    method: 'get'
  })
}
